import { render, staticRenderFns } from "./ComplianceFormNotif.vue?vue&type=template&id=3052a8bd&"
import script from "./ComplianceFormNotif.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormNotif.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormNotif.vue?vue&type=style&index=0&id=3052a8bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports